export default __webpack_public_path__ + "static/12_przybysz-a01e17d466808ad091455bd6b62670ab.png";